export const MARGIN = 48;
export const GRID_SIZE = 10;

export const DRAG_INDEX = "99999";
export const STATIC_INDEX = "99998";

export const DEFAULT_MEMO = {
  id: "9346dc6c-f982-48ce-9e21-f6a334b367b3",
  text: "Manifest is a grid-based pinboard for note taking.\n\nSimply click and drag anywhere to create a memo and snap it to the grid. All memos can be moved, resized, deleted and are saved in your browser's local storage between sessions.\n\nTo toggle between dark and light modes you can press Alt + T.\n\nManifest is free and completely open-source, please consider donating. \n\nhttps://donate.stripe.com/cN23ggaU156agSYaEF \n\nIf you find a bug or have a suggestion feel free to file an issue on Github. \n\nhttps://github.com/jonathontoon/manifest/issues",
  position: {
    top: 50,
    left: 50
  },
  size: {
    width: 400,
    height: 380
  }
};
